import React from 'react';
import { styled } from '@this/constants/themes';
import type Hotel from '@this/src/domain/hotel/hotel';
import type HotelList from '@this/src/domain/hotel/hotel_list';
import type User from '@this/domain/user/user';
import type { HotelBoxProps } from '@this/components/reserve_trip/select/hotel_box/types';
import HotelCandidateBox from '@this/components/reserve_trip/select/hotel_box/hotel_candidate_box';

interface Props {
  destLocation?: { lat: number; lng: number } | null;
  me?: User | null;
  user?: HotelBoxProps['user'];
  hotel: Hotel;
  hotels: HotelList;
  hotelPriceLimit: number | null;
  searchQueryId: number | null;
  serviceId?: number;
  selected: boolean;
  visible: boolean;
  onClose: () => void;
  handleHotelSelect: (hotel: Hotel) => void;
}

const HotelDetailOnMap = ({
  destLocation,
  me,
  user,
  hotel,
  hotels,
  hotelPriceLimit,
  searchQueryId,
  serviceId,
  selected,
  visible,
  onClose,
  handleHotelSelect
}: Props) => {
  return (
    <Wrapper visible={visible}>
      <HotelCandidateBox
        destLocation={destLocation}
        me={me}
        user={user}
        hotel={hotel}
        hotels={hotels}
        selected={selected}
        hotelPriceLimit={hotelPriceLimit}
        searchQueryId={searchQueryId}
        serviceId={serviceId}
        showCloseButton
        onClose={onClose}
        handleSelect={handleHotelSelect}
      />
    </Wrapper>
  );
};

export default HotelDetailOnMap;

const Wrapper = styled.div<{ visible: boolean }>`
  display: ${props => (props.visible ? 'block' : 'none')};
  margin: 0;
`;
